import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { HttpService, NotificationService } from '../../../../tms-shared';
import { TmsWebBaseEditCreateService } from '../../base';
import { UserPrinter } from '../../../models';

@Injectable({
  providedIn: 'root',
})
export class UserPrinterService extends TmsWebBaseEditCreateService<UserPrinter, UserPrinter> {
  constructor(protected httpService: HttpService, protected notificationService: NotificationService) {
    super('UserPrinter', $localize`User Printer`, httpService, notificationService);
  }
  getForUser(id: string): Observable<UserPrinter[]> {
    return this.httpService.get<UserPrinter[]>(`${this.apiUrl}/PrintersForUser?id=${id}`);
  }
}
